<template lang="html">
  <v-row>
    <!-- class="clients-setting-default-height" -->
    <v-col cols="4">
      <v-list two-line avatar>
        <!-- clients list -->
        <v-subheader>CLIENTS</v-subheader>
        <v-list-item v-for="(client, index) in project_clients" :key="'client'+index"
        @click="selected_client_index = index"
        :style="selected_client_index === index? 'background-color: #616161':''">
          <v-list-item-avatar color="grey">
            <span class="white--text">{{ client.name[0].toUpperCase() }}</span>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ client.name }}</v-list-item-title>
            <v-list-item-subtitle>
              <v-chip small class="ma-2">{{ client.base_uri }}</v-chip>
              <v-chip v-if="client.activated" small class="ma-2" color="green" text-color="white">
                <v-avatar left>
                  <v-icon>sync</v-icon>
                </v-avatar>
                active
              </v-chip>
              <v-chip v-else small class="ma-2" color="red" text-color="white">
                <v-avatar left>
                  <v-icon>sync_disabled</v-icon>
                </v-avatar>
                inactive
              </v-chip>
              <StandardDeleteBtn
                v-if="client.owner.id === current_user.id"
                :btnclass="'pull-right'"
                :el="client"
                @deleteClick="deleteClient(client)"
              />

            </v-list-item-subtitle>

          </v-list-item-content>
        </v-list-item>
        <!-- add new client -->
        <v-list-item v-if="!add_new_client" @click="add_new_client = true" class="pointer">
          <v-list-item-avatar color="grey" small>
            <v-icon>add</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Add new client</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-else>
          <v-list-item-content>
            <b>Client Name:</b> <br>
            <StandardTextfield
              color="grey darken-1"
              textcolor="white"
              placeholder="Name"
              :value="new_client.name"
              @changeValue="new_client.name = $event"
              style="width: 90%"
              />
            <b>Client base URI:</b> <br>
            <StandardTextfield
              color="grey darken-1"
              textcolor="white"
              placeholder="Base URI"
              :value="new_client.base_uri"
              @changeValue="new_client.base_uri = $event"
              style="width: 90%"
              />
          </v-list-item-content>
          <v-list-item-avatar color="green" small>
            <v-btn icon @click="addClient()">
              <v-icon>add</v-icon>
            </v-btn>
          </v-list-item-avatar>
        </v-list-item>
      </v-list>
    </v-col>
    <!-- class="clients-setting-default-height" -->
    <v-col cols="8">
      <v-list two-line avatar v-if="project_clients[selected_client_index]">
        <!-- clients list -->
        <v-subheader>CALLBACKS ({{ project_clients[selected_client_index].name }})</v-subheader>
        <v-list-item v-for="(callback, index) in project_clients[selected_client_index].callbacks" :key="'callback'+index">
          <v-list-item-avatar :color="getHTTPColor(callback.callback_http_method)">
            <span class="white--text">{{ callback.callback_http_method }}</span>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              <v-chip small class="ma-2">{{ project_clients[selected_client_index].base_uri + callback.callback_uri }}</v-chip>
              <v-chip small outlined class="ma-2">{{ callback.takt_entity }}</v-chip>
              <v-chip small class="ma-2" :color="getHTTPColor(callback.takt_http_method)">{{ callback.takt_http_method }}</v-chip>
            </v-list-item-title>
            <v-list-item-subtitle>
              <StandardDeleteBtn
                v-if="project_clients[selected_client_index].owner.id === current_user.id"
                :btnclass="'pull-right'"
                :el="callback"
                @deleteClick="deleteCallback(callback)"
              />
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <!-- add new callback -->
        <v-list-item v-if="!add_new_callback" @click="add_new_callback = true" class="pointer">
          <v-list-item-avatar color="grey" small>
            <v-icon>add</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>123 Add new callback</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-else>
          <v-list-item-content>
            <b>Callback URI:</b> <br>
            <StandardTextfield
              color="grey darken-1"
              textcolor="white"
              placeholder="Callback URI"
              :value="new_callback.callback_uri"
              @changeValue="new_callback.callback_uri = $event"
              style="width: 90%"
              />
              <!-- project_clients[selected_client_index].base_uri +  -->
            <b>Callback HTTP Method:</b> <br>
            <StandardDropdown
              class="ma-0"
              header="Callback HTTP Method:"
              :value="new_callback.callback_http_method"
              @changeValue="new_callback.callback_http_method = $event.name"
              placeholder="Callback HTTP Method"
              :options="[{name: 'POST'}, {name: 'PUT'}, {name: 'DELETE'}]"
            />
            <b>TAKT Entity:</b> <br>
            <StandardDropdown
              class="ma-0"
              header="Takt Entity:"
              :value="new_callback.takt_entity"
              @changeValue="new_callback.takt_entity = $event.name"
              placeholder="Callback HTTP Method"
              :options="[{name: 'TWorkPackage'}]"
            />
            <!-- :options="[{name: 'Train'}, {name: 'TaktArea'}, {name: 'TWaggon'}, {name: 'TWorkPackage'}, {name: 'TWorkStep'},
            {name: 'TDefectStep'}, {name: 'TQualityStep'}, {name: 'TDesignStep'}, {name: 'THandoverStep'}, {name: 'TLogisticStep'}]" -->
            <b>TAKT HTTP Method:</b> <br>
            <StandardDropdown
              class="ma-0"
              header="Takt HTTP Method:"
              :value="new_callback.takt_http_method"
              @changeValue="new_callback.takt_http_method = $event.name"
              placeholder="Callback HTTP Method"
              :options="[{name: 'POST'}, {name: 'PUT'}, {name: 'DELETE'}]"
            />
          </v-list-item-content>
          <v-list-item-avatar color="green" small>
            <v-btn icon @click="addCallback()">
              <v-icon>add</v-icon>
            </v-btn>
          </v-list-item-avatar>
        </v-list-item>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue'
import StandardDropdown from '@/components/StandardComponents/StandardDropdown.component.vue'
import StandardDeleteBtn from '@/components/StandardComponents/StandardDeleteBtn.component.vue'
// import {
//   mapActions,
//   mapGetters
// } from 'vuex';
export default {
  components: {
    StandardTextfield, StandardDropdown, StandardDeleteBtn
  },
  props: ['project_clients', 'current_user'],
  data: function () {
    return {
      selected_client_index: 0,
      add_new_client: false,
      add_new_callback: false,
      new_client: {
        name: '',
        base_uri: ''
      },
      new_callback: {
        callback_uri: '',
        callback_http_method: 'POST',
        takt_entity: 'TWorkPackage',
        takt_http_method: 'PUT',
        client: 0
      }
    }
  },
  computed: {

  },
  methods: {
    addClient(){
      this.$emit('addClient', this.new_client);
      let self = this;
      setTimeout(function () {
        self.add_new_client = false;
        self.new_client = {
          name: '',
          base_uri: ''
        };
      }, 3000);
    },
    addCallback(){
      this.new_callback.client = this.project_clients[this.selected_client_index].id;
      this.$emit('addCallback', this.new_callback);
      let self = this;
      setTimeout(function () {
        self.add_new_callback = false;
        self.new_callback = {
          callback_uri: '',
          callback_http_method: 'POST',
          takt_entity: 'TWorkPackage',
          takt_http_method: 'PUT',
          client: 0
        };
      }, 3000);
    },
    getHTTPColor(method){
      switch (method) {
        case 'POST':
          return '#d89f39';
        case 'PUT':
          return '#3a81ba';
        case 'DELETE':
          return '#963334';
      }
    },
    deleteClient(client){
      this.$emit('deleteClient', client.id);
    },
    deleteCallback(callback){
      this.$emit('deleteCallback', {
        callback_id: callback.id,
        client_id: this.project_clients[this.selected_client_index].id
      });
    }
  }
}
</script>

<style lang="css" scoped>
.clients-setting-default-height {
  max-height: 600px;
  overflow-y: auto;
}
</style>
